import React from "react";
import TimeLineForm from "../timelineForm/timelineForm";
import Constants from "../../../constants";
import './timelineList.scss';
import TimelineHome from "../timelineHome/timelineHome";
import Home from "../../../components/home/home";

let self;

export class TimelineList extends React.Component<any, any> {
    timeLineFormForAPI = {};
    defaultForm = {};
    apiKey = ''
    radioData:any = ''
    constructor(props: any) {
        super(props);
        self = this;
        this.state = { noOfTimeline: 1, educationList: [], workExpList:[], isTimelineAdditingDone: false, profileData: {}, timeLineFormForAPI: {}, defaultForm: {}, radioData: '', timeLineFinalDone: false }
    }

    componentDidMount() {
        if (this.props.timeLineType === Constants.timeLineEducationType) {
            this.timeLineFormForAPI = { name: '', cources: '', acedomicYear: '', grade: '' };
            this.defaultForm = { name: '', cources: '', startYear: '', endYear: '', grade: '' };
            this.setState({ timeLineFormForAPI: this.timeLineFormForAPI, defaultForm: this.defaultForm })
            this.apiKey= 'educationList';
        } else {
            this.timeLineFormForAPI = { name: '', designation: '', acedomicYear: '' };
            this.defaultForm = { name: '', designation: '', startYear: '', endYear: '' }
            this.setState({ timeLineFormForAPI: this.timeLineFormForAPI, defaultForm: this.defaultForm })
            this.apiKey= 'workExpList';
        }
        this.radioData = sessionStorage.getItem('radioData')
        this.setState({radioData: this.radioData})
        
    }

    onTimeLineAdded(data, isNext) {
        // console.log(data, isNext)
        let newData = {};
        if (isNext) {
            self.setState({ noOfTimeline: self.state.noOfTimeline + 1 })
        } else {
        //    console.log(self.state.radioData)
            // if(self.state.radioData === Constants.experianced) {
            //     sessionStorage.removeItem('radioData')
            // }
            self.setState({ isTimelineAdditingDone: true })
            const data1: any = sessionStorage.getItem('portfolioForm')
            const previousData = JSON.parse(data1);
            // newData = { ...previousData, educationList: [...self.state.educationList, data] }
            newData = { ...previousData, [self.apiKey]: [...self.state[self.apiKey], data] }
            sessionStorage.setItem('portfolioForm', JSON.stringify(newData))
        }
        // self.setState({ educationList: [...self.state.educationList, data] });
        self.setState({ [self.apiKey]: [...self.state[self.apiKey], data]});
        self.setState({ profileData: newData });
    }
    handleRadioChange(event:any) {
        // console.log(event.target.value)
        self.setState({radioData: event.target.value})
    }
    render(): React.ReactNode {
        return (
            <>
                {(!this.state.isTimelineAdditingDone) &&
                 <div className="form__wrapper">
                        {
                            Array.from({ length: this.state.noOfTimeline }).map((e, i) => {
                                return <TimeLineForm onTimeLineAdded={this.onTimeLineAdded} key={i} timeLineNo={this.props.timeLineType} defaultForm={this.state.defaultForm} timeLineFormForAPI={this.state.timeLineFormForAPI} />
                            })
                        }
                    </div>
                }
                {/* {
                     (this.state.isTimelineAdditingDone && this.state.radioData === Constants.experianced) &&
                     <TimelineList  timeLineType={Constants.timelineworkExpType} /> 
                } */}
                {/* {
                    (this.state.isTimelineAdditingDone) &&
                    <TimelineHome timeLineType={Constants.timelineworkExpType} type={this.state.radioData}  ></TimelineHome>
                } */}
                {   (this.state.isTimelineAdditingDone) &&
                    <Home  profileData={this.state.profileData} /> 
                }
            </>
        )
    }
}

export default TimelineList;